import React from "react";
import { Container } from "@material-ui/core";
import DropZone from "../DropZone";
import UploadModal from "../DropZone/components/UploadModal";
import RecentImports from "./components/RecentImports";
import HistoryImports from "./components/HistoryImports";
import { useDropZoneDispatch } from "../contexts/drop-zone-context";
import { StatusMap } from "../../enum/ImportZones";
import { timeout } from "../../services/helpers";
import { S3_BUCKETS } from "../../backendServices/s3";
import {uploadToS3, updateImportCsvRecord, getImportCsvRecordsForAccount, getFromS3} from "../../services/backendApi";
import "./style.css";

const ImportZones = ({ id }) => {
  const csvTemplateUrl = `https://${process.env.IMPORT_CSV_S3_BUCKET}.s3-${process.env.REGION}.amazonaws.com/import-zones-template.csv`;
  const { requiresFilesUpdate } = useDropZoneDispatch();

  const deleteFile = async (fileId) => {
    try {
      await updateImportCsvRecord(fileId, id, StatusMap.DELETED.status);
      requiresFilesUpdate();
    } catch (error) {
      console.error("error", error);
      alert("There was an issue updating File status to delete a file");
    }
  };

  const onUploadFile = async (file) => {
    const filesCount = (
      await getImportCsvRecordsForAccount(id)
    ).Count;

    // Uploading a new file will trigger lambda that validates file's content and updates DynamoDB
    // This Lambda belongs to the Canvas Import CSV service
    await uploadToS3(file, id, S3_BUCKETS.IMPORT_CSV);

    // Wait for the new file info to be updated in the DB
    let currentFilesCount = (
      await getImportCsvRecordsForAccount(id)
    ).Count;

    // If the record hasn't been updated wait 1 second and check again
    while (filesCount === currentFilesCount) {
      const DELAY = 1000; // 1 Second
      await timeout(DELAY);
      currentFilesCount = (
        await getImportCsvRecordsForAccount(id)
      ).Count;
    }
  };

  return (
    <div>
      <div className="import-zones">
        <Container maxWidth="xl" className="white-card main-container">
          <h5 className="title">IMPORT ZONES</h5>
          <div className="main-sections-wrapper">
            <div>
              <p>Import a CSV of Zones information to add Zones</p>
              <Container className="important-message">
                <div>
                  <h6>Important</h6>
                </div>
                <div>
                  <ul>
                    <li>
                      Imported CSV files must follow{" "}
                      <a onClick={() => getFromS3(S3_BUCKETS.IMPORT_CSV, "import-zones-template.csv")} className="pointer-cursor">this template</a>
                    </li>
                    <li>
                      This is a two step process, first import the CSV, second
                      create the Zones
                    </li>
                  </ul>
                </div>
              </Container>
            </div>
            <div className="uploader-wrapper">
              <DropZone
                allowedFileExtensions={["csv"]}
                allowedMimeTypes={[
                  "text/csv",
                  "text/plain",
                  "application/csv",
                  "text/comma-separated-values",
                  "application/excel",
                  "application/vnd.ms-excel",
                  "application/vnd.msexcel",
                  "text/anytext",
                  "application/octet-stream",
                  "application/txt",
                ]}
                fileDescription="CSV"
              />
            </div>
          </div>
        </Container>
        <RecentImports accountId={id} deleteFile={deleteFile} />
        <HistoryImports deleteFile={deleteFile} />
      </div>
      <UploadModal onUploadFile={onUploadFile} />
    </div>
  );
};

export default ImportZones;
